import { Autocomplete, TextField, CircularProgress } from '@mui/material'
import { useGetMembersByTierQuery } from 'store/dashboard'

interface TierFilterProps {
  value: string[]
  onChange: (value: string[]) => void
}

const TierFilter = ({ value, onChange }: TierFilterProps) => {
  const { data: tierList, isLoading } = useGetMembersByTierQuery({})

  const options = (tierList ?? []).map((t) => ({ label: t.tierName, id: t.tierName }))
  const selected = options.filter((o) => value.includes(o.id))

  return (
    <Autocomplete
      data-download-hide='true'
      multiple
      disablePortal
      fullWidth
      // size='small'
      options={options}
      isOptionEqualToValue={(o, v) => o.id === v.id}
      value={selected}
      onChange={(_, val) => onChange(val.map((v) => v.id))}
      renderInput={(params) => (
        <TextField
          {...params}
          label='Member Tier'
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <>
                {isLoading && <CircularProgress color='inherit' size={20} />}
                {params.InputProps.endAdornment}
              </>
            )
          }}
        />
      )}
    />
  )
}

export default TierFilter
